import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaCheck, FaChevronDown, FaExchangeAlt } from "react-icons/fa";

export default function RangePeriodMode({
  displayLabel,
  filters,
  isOpen,
  isRTL,
  onChange,
  onClose,
  onOpen,
  onSwitchToSingle,
  rangeStep,
  setRangeStep,
  t,
}) {
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom" isLazy>
      <PopoverTrigger>
        <Button
          w="full"
          variant="outline"
          size="sm"
          h="40px"
          textAlign={isRTL ? "right" : "left"}
          borderColor="purple.300"
          onClick={
            !isOpen
              ? () => {
                  setRangeStep("from");
                  onOpen();
                }
              : undefined
          }
        >
          <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
            <FaExchangeAlt color="var(--chakra-colors-purple-500)" />
            <Text noOfLines={1} flex={1} fontSize="xs">
              {displayLabel}
            </Text>
            <FaChevronDown />
          </HStack>
        </Button>
      </PopoverTrigger>
      <PopoverContent w="340px">
        <PopoverArrow />
        <PopoverBody p={3}>
          <VStack spacing={3} align="stretch">
            <HStack bg="purple.50" justify="space-between" borderRadius="md" p={2}>
              <Text fontSize="xs" fontWeight="bold" color="purple.700">
                {isRTL ? "📅 نطاق تاريخ مخصص" : "📅 Custom date range"}
              </Text>
              <Button size="xs" variant="ghost" colorScheme="gray" onClick={onSwitchToSingle}>
                {isRTL ? "فترة واحدة" : "Single Period"}
              </Button>
            </HStack>
            <HStack align="start" spacing={3}>
              <FormControl>
                <FormLabel fontSize="xs" mb={1}>
                  {isRTL ? "من" : "From"}
                </FormLabel>
                <Input
                  size="sm"
                  type="date"
                  value={filters.periodFrom || ""}
                  onFocus={() => setRangeStep("from")}
                  onChange={(event) => onChange("periodFrom", event.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="xs" mb={1}>
                  {isRTL ? "إلى" : "To"}
                </FormLabel>
                <Input
                  size="sm"
                  type="date"
                  value={filters.periodTo || ""}
                  onFocus={() => setRangeStep("to")}
                  onChange={(event) => onChange("periodTo", event.target.value)}
                />
              </FormControl>
            </HStack>
            <Text fontSize="xs" color="gray.500">
              {filters.periodFrom || filters.periodTo
                ? `${isRTL ? "الفترة المختارة:" : "Selected range:"} ${displayLabel}`
                : t("reports.selectRange", "Select a custom range")}
            </Text>
            <Text fontSize="xs" color="purple.500">
              {rangeStep === "to"
                ? isRTL
                  ? "اختر تاريخ النهاية"
                  : "Select the end date"
                : isRTL
                ? "اختر تاريخ البداية"
                : "Select the start date"}
            </Text>
            <Button
              size="sm"
              w="full"
              colorScheme="purple"
              onClick={onClose}
              leftIcon={<FaCheck />}
              isDisabled={!filters.periodFrom || !filters.periodTo}
            >
              {isRTL ? "تم" : "Done"}
            </Button>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
